export default [
    {
        path: '/fill-picking-cart/show',
        name: 'fill-picking-cart_show',
        component: () => import('@src/fill-picking-cart/fill-picking-cart-show.vue'),
        meta: {
            title: 'Pickwagen befüllen',
            role: 'ROLE_FILL_PICKING_CART',
        },
    },
];
